import PropTypes from 'prop-types';
import pdfImage from 'assets/icon-pdf.svg';
import docImage from 'assets/icon-doc.svg';
import photoImage from 'assets/photo.svg';
import Icon from 'Components/Atoms/Icon/Icon';
import { formatLongDate, formatFileSize } from 'Utils/formatters';
import Spinner from 'Components/Atoms/Spinner';
import { cn } from 'Utils/cn';
import OutlineDownload from 'Components/Atoms/OutlineIcons/OutlineDownload';

const getImageByType = (type) => {
    if (type.includes('pdf')) return pdfImage;
    if (type.includes('word')) return docImage;
    if (type.includes('image')) return photoImage;

    return docImage;
};

export default function File(props) {
    const { file, onDelete, onDownload, loading, className } = props;

    const handleDelete = () => {
        if (loading) return;

        onDelete(file);
    };

    const handleDownload = (ev) => {
        ev.preventDefault();
        if (loading) return;

        onDownload(file);
    };

    return (
        <div
            className={cn(
                'grid grid-cols-[64px_1fr_auto] gap-3 items-center md:gap-5 md:grid-cols-[84px_1fr_auto]',
                className,
            )}
        >
            <a
                href="#"
                onClick={handleDownload}
                className="rounded-sm bg-gray-100 flex items-center justify-center min-h-16"
            >
                {loading && <Spinner size={24} />}
                {!loading && <img src={getImageByType(file.type)} alt={file.type} />}
            </a>
            <div className="min-w-0">
                <div className="truncate block font-semibold">{file.name}</div>

                <div className="text-xs text-gray-500 pt-1">
                    <span>{formatFileSize(file.size)}</span>
                    <span className="w-4 hidden sm:inline-block" />
                    <span className="hidden sm:inline-block">{formatLongDate(file.creation_date)}</span>
                </div>
            </div>

            <div className="flex justify-end items-center">
                <button
                    type="button"
                    className="inline-flex size-10 text-dark-blue items-center justify-center"
                    onClick={handleDownload}
                >
                    <OutlineDownload color="currentColor" />
                </button>
                <button
                    type="button"
                    className="inline-flex size-10 text-dark-blue items-center justify-center"
                    onClick={handleDelete}
                >
                    <Icon name="trash" size={20} color="currentColor" />
                </button>
            </div>
        </div>
    );
}

File.propTypes = {
    file: PropTypes.shape({
        name: PropTypes.string.isRequired,
        size: PropTypes.number.isRequired,
        type: PropTypes.string.isRequired,
        creation_date: PropTypes.instanceOf(Date).isRequired,
    }).isRequired,
    onDelete: PropTypes.func.isRequired,
    onDownload: PropTypes.func.isRequired,
    loading: PropTypes.bool,
    className: PropTypes.string,
};
